import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Globaltreats";
const BASE_URL = "https://globaltreats.in";
const DEFAULT_IMAGE = `${BASE_URL}/assets/og-banner.jpg`;

// Per-page SEO. Falls back to sensible bakery defaults targeting Noida / Greater Noida.
export const Seo = ({ title, description, path = "", image = DEFAULT_IMAGE, noindex = false, jsonLd = null }) => {
  const fullTitle = title ? `${title} | ${SITE}` : `Order Cakes Online in Noida & Greater Noida | ${SITE}`;
  const desc =
    description ||
    "Order fresh, hand-decorated cakes online in Noida & Greater Noida. Birthday, anniversary, designer, photo & custom cakes with next-day delivery from Globaltreats.";
  const url = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
